import FileExport from './file-export.vue';
export default FileExport;


// WEBPACK FOOTER //
// ./src/components/file-export/index.js